export default __webpack_public_path__ + "static/media/logo.452b67a4.png";